// extracted by mini-css-extract-plugin
export var calendarView = "_mp-0";